<div class="card pt-4">
  <div class="grid">
    <div class="flex flex-column col-12 xl:col-4 pr-0">
      <div>
        <p class="ml-2 mt-2 mb-6 title h1-font-size">
          {{'common.settings' | transloco}}
        </p>
      </div>
      <div class="flex pl-2">
        <div class="flex flex-column w-full">
          <div class="flex flex-column justify-content-between">
            <div class="flex justify-content-between align-items-center">
              <p class="bold mb-0">{{'options.theme' | transloco}}:</p>
              <button pButton pRipple icon="pi pi-replay" iconPos="right"
                      (click)="restoreDefaultColors()" [label]="'options.restore' | transloco"></button>
            </div>
            <div class="grid mt-2">
              <div class="col-12 xl:col-4 flex flex-column align-items-center">
                <p class="mb-0">{{'options.primary' | transloco}}</p>
                <label [style.background-color]="primaryColor" class="theme-picker cursor-pointer">
                  <input [(ngModel)]="primaryColor" type="color" (ngModelChange)="onPrimaryColorChange($event)">
                </label>
              </div>
              <div class="col-12 xl:col-4 flex flex-column align-items-center">
                <p class="mb-0">{{'options.secondary' | transloco}}</p>
                <label [style.background-color]="secondaryColor" class="theme-picker cursor-pointer">
                  <input [(ngModel)]="secondaryColor" type="color" (ngModelChange)="onSecondaryColorChange($event)">
                </label>
              </div>
              <div class="col-12 xl:col-4 flex flex-column align-items-center">
                <p class="mb-0">{{'options.tertiary' | transloco}}</p>
                <label [style.background-color]="tertiaryColor" class="theme-picker cursor-pointer">
                  <input [(ngModel)]="tertiaryColor" type="color" (ngModelChange)="onTertiaryColorChange($event)">
                </label>
              </div>
            </div>
          </div>
          <hr>
          <div class="flex flex-column justify-content-between">
            <div class="flex justify-content-between align-items-center">
              <p class="bold mb-0">{{'options.icon' | transloco}}:</p>
              <button pButton pRipple icon="pi pi-replay" iconPos="right"
                      (click)="restoreDefaultIcon()" [label]="'options.restore' | transloco"></button>
            </div>
            <div class="flex flex-column align-items-center mt-5">
              <div class="flex justify-content-center icon-preview-container mb-2">
                <img [src]="icon" style="max-height: 150px">
              </div>
              <div>
                <label class="cursor-pointer p-button p-button-icon-only mr-2" pRipple>
                  <i class="pi pi-upload" style="font-size: 16px"></i>
                  <input #imageInput type="file" accept="image/*" (change)="onUploadIcon(imageInput)" class="hidden">
                </label>
              </div>
            </div>
            <div class="flex justify-content-center mt-2">

            </div>
          </div>
          <hr>
          <div class="flex flex-column justify-content-between">
            <p class="bold mb-0">{{'options.applyChanges' | transloco}}:</p>
            <div class="flex justify-content-center mt-3">
              <p-selectButton [options]="applyOptions" [(ngModel)]="applyOption"></p-selectButton>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-5 xl:mt-auto flex justify-content-between pl-2">
        <button pButton pRipple [label]="'common.cancel' | transloco" class="p-button-danger" routerLink="/"></button>
        <button pButton pRipple [label]="'common.save' | transloco" (click)="onSaveChanges()"></button>
      </div>
    </div>
    <div class="flex col-12 xl:col-8">
      <p-divider class="hidden xl:block" layout="vertical"></p-divider>
      <div class="flex flex-column flex-1">
        <div>
          <p class="ml-2 mt-2 mb-6 title h1-font-size">
            {{'common.preview' | transloco}}
          </p>
        </div>
        <p-selectButton [(ngModel)]="previewOption" [options]="previewOptions" optionValue="value" class="align-self-center mb-3"></p-selectButton>
        <div class="flex flex-column px-2">
          <div style="background-color: #E9E9E9; border: 1px solid #3A3A3A; border-radius: 3px;">
            <div class="preview-topbar" style="box-shadow: 0 2px 10px 0 rgb(0 0 0 / 16%)">
              <div class="pb-0">
                <div class="flex justify-content-between">
                  <div class="flex align-items-center">
                    <img id="topbar-logo" [src]="icon" height="42px">
                    <div class="ml-3 cursor-pointer">
                      <a class="icon-white"><i class="pi pi-bars topbar-icon"></i></a>
                    </div>
                  </div>
                  <div class="flex align-items-center">
                    <p-avatar pRipple icon="pi pi-user" [style.margin-bottom]="'2px'"
                              shape="circle" class="cursor-pointer mr-2" styleClass="topbar-avatar"></p-avatar>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-2" style="padding: 12px">
              <preview-list *ngIf="previewOption === 'list'"></preview-list>
              <preview-form *ngIf="previewOption === 'form'"></preview-form>
              <preview-details *ngIf="previewOption === 'details'"></preview-details>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
